module.exports = __webpack_public_path__ + "0a22fa5fc2ce7bcf17cb582f28e515f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/a2p-1.png
// module id = 837
// module chunks = 0